import React, { useState } from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [showThankYou, setShowThankYou] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setShowThankYou(true);

    setTimeout(() => {
      setShowThankYou(false);

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });
    }, 5000);
  };

  return (
    <>
      <Helmet>
        <title>Επικοινωνία - Ferupen Barbershop</title>
        <meta
          name="description"
          content="Επικοινωνήστε με το Ferupen Barbershop. Είμαστε εδώ για να απαντήσουμε σε κάθε ερώτησή σας."
        />
      </Helmet>

      <div className="contact-container">
        <h1>Επικοινωνήστε μαζί μας</h1>

        <div className="contact-grid">
          <div className="contact-info">
            <h2>Στοιχεία Επικοινωνίας</h2>

            <div className="contact-item">
              <div className="contact-icon">
                <FaHome />
              </div>
              <div className="contact-item-details">
                <h3>Διεύθυνση</h3>
                <p>Ermou 36</p>
                <p>Markopoulo Mesogeas 190 03</p>
                <p>Ελλάδα</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaPhone />
              </div>
              <div className="contact-item-details">
                <h3>Τηλέφωνο</h3>
                <p>+302299022996</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <div className="contact-item-details">
                <h3>Email</h3>
                <p>
                  <a href="mailto:ferupen@hotmail.com">ferupen@hotmail.com</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-details">
                <h3>Ωράριο Λειτουργίας</h3>
                <p>Δευτέρα - Παρασκευή: 09:00 - 20:00</p>
                <p>Σάββατο: 09:00 - 18:00</p>
                <p>Κυριακή: Κλειστά</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-details">
                <h3>ΑΦΜ</h3>
                <p>87657353</p>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Στείλτε μας Μήνυμα</h2>

            {showThankYou && (
              <p className="success-message">
                Ευχαριστούμε για το μήνυμά σας! Θα επικοινωνήσουμε σύντομα μαζί
                σας.
              </p>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Ονοματεπώνυμο</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Τηλέφωνο</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  pattern="^\+?[0-9\s\-]{7,20}$"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Μήνυμα</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="submit-contact-btn">
                Αποστολή Μηνύματος
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
